// ─── Self-hosted images (downloaded from idpsmahore.com so the site
// never depends on hotlinking their live server) ───────────────
import slider3 from "../assets/images/slider/slider3.webp";
import portfolioArt from "../assets/images/portfolio/art.webp";
import portfolioLabs from "../assets/images/portfolio/labs.webp";
import portfolioTrafic from "../assets/images/portfolio/trafic.webp";
import portfolioGallery3 from "../assets/images/portfolio/gallery-3.webp";
import portfolioMath from "../assets/images/portfolio/math.webp";
import portfolioGallery9 from "../assets/images/portfolio/gallery-9.webp";
import campusDigitalClass from "../assets/images/campus/digitalclass.webp";
import campusClassroom from "../assets/images/campus/classroom.webp";
import campusSchoolbus from "../assets/images/campus/schoolbus.webp";
import classEducation from "../assets/images/class/education.webp";
import classGaming from "../assets/images/class/gaming.webp";
import classActivite from "../assets/images/class/activite.webp";

// ─── School Info ─────────────────────────────────────────────
export const SCHOOL = {
  name: "International Delhi Public School",
  short: "IDPS Mahore",
  phone: "+91 9622208317",
  email: "info_mahore@idpssociety.com",
  address:
    "International Delhi Public School, Mahore, Near Petrol Pump, District Reasi, J&K – 182315",
  timing: "Mon–Fri : 9:00 AM – 6:00 PM",
  whatsapp: "https://wa.me/+919622208317",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13400!2d75.07!3d33.27!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sMahore%2C+Reasi!5e0!3m2!1sen!2sin!4v1600000000000",
};

// ─── Hero Slides ────────────────────────────────────────────
export const SLIDES = [
  {
    img: slider3,
    title: "Nurturing Young Minds",
    highlight: "for a Brighter Tomorrow",
  },
  {
    img: portfolioLabs,
    title: "Exploring Science",
    highlight: "Through Hands-on Learning",
  },
  {
    img: portfolioArt,
    title: "Creativity & Expression",
    highlight: "Beyond the Classroom",
  },
];

// ─── Navigation ─────────────────────────────────────────────
export const NAV_ITEMS = [
  { label: "Home", path: "/" },
  {
    label: "About",
    path: "/about",
    children: [
      { label: "About IDPS Mahore", path: "/about" },
      { label: "Mission & Vision", path: "/mission-vision" },
      { label: "Aim & Objective", path: "/aim-objective" },
    ],
  },
  {
    label: "Admissions",
    path: "/admissions",
    children: [
      { label: "Admission Guidelines", path: "/admissions" },
      { label: "Enquire Online", path: "/contact" },
    ],
  },
  {
    label: "Academics",
    path: "/academics",
    children: [
      { label: "School Timings", path: "/academics" },
      { label: "Academic Programs", path: "/academics" },
      { label: "Methodology", path: "/academics" },
      { label: "Curriculum", path: "/academics" },
    ],
  },
  { label: "Life @ IDPS", path: "/life-at-idps" },
  {
    label: "Campus",
    path: "/campus",
    children: [
      { label: "Digital Classroom", path: "/campus" },
      { label: "Auditorium", path: "/campus" },
      { label: "Sick Bay", path: "/campus" },
      { label: "CCTV Coverage", path: "/campus" },
      { label: "AC Classrooms", path: "/campus" },
      { label: "Activity Rooms", path: "/campus" },
      { label: "Library", path: "/campus" },
      { label: "Transport Facility", path: "/campus" },
    ],
  },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact", path: "/contact" },
];

// ─── Notifications ──────────────────────────────────────────
export const NOTIFICATIONS = [
  "Admission Open for Session 2026-27 — Limited Seats Available",
  "Enquire Now for Grade Nursery to 8th",
  "Holistic Education with Indian Values",
  "Job Fair — Positions Available for Qualified Teachers",
];

// ─── Campus Facilities ──────────────────────────────────────
export const CAMPUS_DATA = [
  {
    title: "Digital Classrooms",
    icon: "monitor",
    img: campusDigitalClass,
    desc: "Our Digital Classrooms integrate advanced technology to enhance learning. Equipped with smart boards, projectors, and multimedia tools, they make lessons more interactive and engaging. Digital content, animations, and real-time assessments help students grasp complex concepts with ease. These classrooms promote a dynamic learning environment, encouraging student participation and creativity.",
  },
  {
    title: "Auditorium",
    icon: "theater",
    img: classActivite,
    desc: "Our auditorium is a world-class facility designed to host cultural performances, academic seminars, guest lectures, competitions, and annual celebrations. Equipped with high-definition audio-visual systems, a professionally lit stage, and comfortable seating, it creates an immersive experience for both performers and audience.",
  },
  {
    title: "Sick Bay",
    icon: "heart-pulse",
    img: campusClassroom,
    desc: "The Sick Bay ensures the health and safety of students by providing immediate medical care. Staffed with a trained nurse, it is equipped with first-aid kits, essential medicines, and basic medical equipment to handle minor injuries and sudden illnesses.",
  },
  {
    title: "CCTV Coverage",
    icon: "video",
    img: portfolioTrafic,
    desc: "High-resolution cameras are strategically installed across the campus, including classrooms, corridors, entry and exit points, playgrounds, and common areas. Continuous monitoring helps maintain discipline and ensure quick response to emergencies. The surveillance system operates 24/7.",
  },
  {
    title: "AC Classrooms",
    icon: "snowflake",
    img: classEducation,
    desc: "Air-Conditioned Classrooms provide a comfortable and conducive learning environment. Modern air-conditioning systems ensure optimal temperature control, allowing students to focus on studies without discomfort from extreme weather conditions.",
  },
  {
    title: "Activity Rooms",
    icon: "palette",
    img: portfolioGallery9,
    desc: "Activity Rooms provide a creative and engaging space for students to explore their talents beyond academics. Designed for art, music, dance, drama, and other skill-building programs, these rooms encourage teamwork, creativity, and confidence.",
  },
  {
    title: "Library",
    icon: "book-open",
    img: portfolioMath,
    desc: "Our Library is a hub of knowledge, fostering a love for reading and lifelong learning. Stocked with a vast collection of books, magazines, and digital resources, it caters to students of all age groups with comfortable seating and modern facilities.",
  },
  {
    title: "Transport Facility",
    icon: "bus",
    img: campusSchoolbus,
    desc: "Our fleet of well-maintained buses is equipped with GPS tracking, CCTV cameras, and first-aid kits for added security. Each bus is driven by a trained driver and accompanied by a caretaker. Routes are carefully planned to cover major residential areas.",
  },
];

// ─── Gallery Images ─────────────────────────────────────────
export const GALLERY_IMGS = [
  portfolioArt,
  portfolioTrafic,
  portfolioLabs,
  portfolioGallery3,
  portfolioMath,
  portfolioGallery9,
];

// ─── Features (Home) ───────────────────────────────────────
export const FEATURES = [
  {
    icon: "book-open",
    title: "Active Learning",
    desc: "Collaboration, critical thinking, and real-world problem-solving in dynamic classrooms.",
  },
  {
    icon: "teacher",
    title: "Expert Teachers",
    desc: "Highly qualified teachers who inspire and mentor every student to reach their potential.",
  },
  {
    icon: "users",
    title: "Parents Day",
    desc: "Celebrating the vital role of parents in nurturing students' growth and achievements.",
  },
  {
    icon: "music",
    title: "Music & Arts",
    desc: "Inspiring creativity, confidence, and a deep appreciation for the performing arts.",
  },
];

// ─── Quick Links (Home) ─────────────────────────────────────
export const QUICK_LINKS = [
  { icon: "clipboard", label: "Admissions 2026-27", path: "/admissions" },
  { icon: "newspaper", label: "News & Events", path: "/life-at-idps" },
  { icon: "school", label: "Campus Tour", path: "/campus" },
  { icon: "trophy", label: "Achievements", path: "/gallery" },
  { icon: "phone", label: "Contact Us", path: "/contact" },
  { icon: "camera", label: "Photo Gallery", path: "/gallery" },
];

// ─── Counters (Home) ────────────────────────────────────────
export const COUNTERS = [
  { num: "500+", label: "Students Enrolled", icon: "graduation-cap" },
  { num: "40+", label: "Qualified Teachers", icon: "teacher" },
  { num: "25+", label: "Classrooms", icon: "school" },
  { num: "10+", label: "School Buses", icon: "bus" },
];

// ─── Classes (Academics) ────────────────────────────────────
export const CLASSES = [
  {
    img: classEducation,
    title: "Drawing Classes",
    desc: "Curated to inspire creativity and mastery. Students explore various techniques with expert guidance.",
  },
  {
    img: classGaming,
    title: "Gaming & Logic",
    desc: "Immersive learning through captivating narratives and logical gameplay experiences.",
  },
  {
    img: classActivite,
    title: "Dance Classes",
    desc: "A joyful outlet for students to develop coordination, confidence, and teamwork.",
  },
];

// ─── Academic Programs ──────────────────────────────────────
export const PROGRAMS = [
  {
    title: "Pre-Primary (Nursery–UKG)",
    desc: "Play-based learning with focus on language, numbers, motor skills, creativity, and social development through activities, stories, and art.",
    color: "#f59e0b",
  },
  {
    title: "Primary (Grade I–V)",
    desc: "Strong academic foundation in English, Hindi, Mathematics, EVS, and Computer Science with co-curricular activities for holistic growth.",
    color: "#3b82f6",
  },
  {
    title: "Middle School (Grade VI–VIII)",
    desc: "Advanced curriculum covering Science, Mathematics, Social Studies, English, Hindi, Computer Science, and Art Education with lab-based learning.",
    color: "#10b981",
  },
];

// ─── School Timings ─────────────────────────────────────────
export const TIMINGS = [
  ["Pre-Primary (Nursery–UKG)", "8:30 AM – 12:30 PM"],
  ["Primary (Grade I–V)", "8:00 AM – 2:00 PM"],
  ["Middle School (Grade VI–VIII)", "8:00 AM – 2:30 PM"],
  ["Office Hours", "9:00 AM – 6:00 PM"],
];

// ─── Admission Steps ────────────────────────────────────────
export const ADMISSION_STEPS = [
  {
    n: "01",
    title: "Enquiry",
    desc: "Fill the online enquiry form or visit the school reception to get information about the admission process.",
  },
  {
    n: "02",
    title: "Registration",
    desc: "Complete the registration form with required documents and pay the registration fee.",
  },
  {
    n: "03",
    title: "Interaction",
    desc: "An interaction session with the child and parents is conducted to assess readiness and compatibility.",
  },
  {
    n: "04",
    title: "Admission",
    desc: "Upon successful interaction, admission is confirmed and the fee payment process is completed.",
  },
];

// ─── Documents Required ─────────────────────────────────────
export const DOCUMENTS_REQUIRED = [
  "Birth Certificate of the child",
  "Aadhar Card of the child and parents",
  "Recent passport-size photographs (4 nos.)",
  "Previous school Transfer Certificate (if applicable)",
  "Report card of the previous class (if applicable)",
  "Address Proof (Ration Card / Electricity Bill)",
];

// ─── Life @ IDPS Activities ─────────────────────────────────
export const ACTIVITIES = [
  { icon: "activity", title: "Sports & Games", desc: "Regular sports activities including cricket, football, basketball, badminton, and athletics to promote physical fitness." },
  { icon: "palette", title: "Art & Craft", desc: "Creative sessions to develop artistic skills through painting, clay modeling, origami, and various craft activities." },
  { icon: "music", title: "Dance & Music", desc: "Classical and contemporary dance training along with vocal and instrumental music classes." },
  { icon: "mic", title: "Public Speaking", desc: "Debates, extempore, elocution, and MUN sessions to build confidence and communication skills." },
  { icon: "flask", title: "Science Club", desc: "Hands-on experiments, science fairs, and innovation challenges to foster scientific temper." },
  { icon: "book-open", title: "Reading Club", desc: "Book reading sessions, story telling, and creative writing workshops to develop language skills." },
  { icon: "drama", title: "Drama & Theatre", desc: "Annual plays, skit performances, and role-playing activities for personality development." },
  { icon: "leaf", title: "Eco Club", desc: "Environmental awareness programs, tree plantation drives, and waste management initiatives." },
];
